// extracted by mini-css-extract-plugin
module.exports = {"component":"LoadingOverlay_component__6O0Cs","background":"LoadingOverlay_background__LzDam"};